module.exports = __webpack_public_path__ + "img/groupImg1.41d15d53.svg";